import request from '../../utils/request';

function fetchPostulations(params = {}) {
  return request({
    url: '/catalog-postulations',
    method: 'GET',
    private: true,
    params,
  });
}

function fetchRegions() {
  return request({
    url: '/regions',
    method: 'GET',
    private: true,
  });
}

function fetchPostulationByUser(userId) {
  return request({
    url: `/catalog-postulations/user/${userId}`,
    method: 'GET',
    private: true,
  });
}

function updatePostulationClassification(id, classification) {
  return request({
    url: `/catalog-postulations/${id}/classification`,
    method: 'PATCH',
    private: true,
    data: classification,
  });
}

function updatePostulationFeaturedContexts(id, featuredContexts = []) {
  return request({
    url: `/catalog-postulations/${id}/featured-contexts`,
    method: 'PATCH',
    private: true,
    data: {
      featuredContexts,
    },
  });
}

function updatePostulationStatus(id, status, rejectionReason = null) {
  return request({
    url: `/catalog-postulations/${id}/status/${status}`,
    method: 'PATCH',
    private: true,
    ...(rejectionReason
      ? {
          data: {
            rejectionReason,
          },
        }
      : {}),
  });
}

function fetchOccasions() {
  return request({
    url: '/catalog-occasions',
    method: 'GET',
    private: true,
  });
}

function createOccasionUploadUrl(fileName, fileType) {
  return request({
    url: '/catalog-occasions/upload-url',
    method: 'POST',
    private: true,
    data: {
      fileName,
      fileType,
    },
  });
}

function uploadOccasionBanner({ fileName, fileType, fileData }) {
  return request({
    url: '/catalog-occasions/upload-banner',
    method: 'POST',
    private: true,
    data: {
      fileName,
      fileType,
      fileData,
    },
  });
}

function createOccasion(data) {
  return request({
    url: '/catalog-occasions',
    method: 'POST',
    private: true,
    data,
  });
}

function updateOccasion(id, data) {
  return request({
    url: `/catalog-occasions/${id}`,
    method: 'PATCH',
    private: true,
    data,
  });
}

function activateOccasion(id) {
  return request({
    url: `/catalog-occasions/${id}/activate`,
    method: 'PATCH',
    private: true,
  });
}

function deactivateOccasion() {
  return request({
    url: '/catalog-occasions/deactivate',
    method: 'PATCH',
    private: true,
  });
}

function deleteOccasion(id) {
  return request({
    url: `/catalog-occasions/${id}`,
    method: 'DELETE',
    private: true,
  });
}

const CatalogApi = {
  activateOccasion,
  createOccasion,
  createOccasionUploadUrl,
  deactivateOccasion,
  deleteOccasion,
  fetchOccasions,
  fetchPostulationByUser,
  fetchPostulations,
  fetchRegions,
  uploadOccasionBanner,
  updateOccasion,
  updatePostulationClassification,
  updatePostulationFeaturedContexts,
  updatePostulationStatus,
};

export default CatalogApi;
